import createSvgIcon from '../Utils/CreateSvgIcon';

export const NewCar = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M15.0709 11.5094L5.77834 13.6213C5.32305 13.7248 4.99996 14.1296 4.99996 14.5965L4.99996 17L7.03541 17C7.27802 15.3039 8.73673 14 10.5 14C12.2632 14 13.7219 15.3038 13.9645 17L21 17L21 19L13.6631 19C13.1014 20.1825 11.8962 21 10.5 21C9.10376 21 7.89851 20.1825 7.33678 19L3.99996 19L2.99996 19L2.99996 18L2.99996 14.5965C2.99996 13.1958 3.96923 11.9815 5.3351 11.6711L14.4656 9.59594L18.2526 5.33563L19.7474 6.66436L17.0761 9.66954L21.083 10.0035L20.9169 11.9965L15.0709 11.5094ZM10.5 19C11.3284 19 12 18.3284 12 17.5C12 16.6716 11.3284 16 10.5 16C9.67153 16 8.99996 16.6716 8.99996 17.5C8.99996 18.3284 9.67153 19 10.5 19ZM5.96573 2.60023L8.38405 4.50316L11.43 4.06431L9.52692 6.48277L9.96573 9.52843L7.54742 7.6255L4.50175 8.06431L6.40458 5.64614L5.96573 2.60023Z"
  />,
  'NewCar',
);
